import * as React from 'react'

import { FeaturesGrid, Feature } from 'components/features-grid/FeaturesGrid'
import { Text, TextName } from 'sdk'
import { Button } from 'sdk/button/Button'

import { useWindowSize } from 'core/hooks/useWindowSize'
import type { PlatformCustomizeDeployCmsContent } from 'core/services/cms/interfaces'

import classes from './style.module.scss'

interface CustomizeDeploySectionProps {
  content: PlatformCustomizeDeployCmsContent
}

export const CustomizeDeploySection: React.FC<CustomizeDeploySectionProps> = ({ content }) => {
  const { width } = useWindowSize()
  const isAboveLg = width > 768
  const features: Feature[] = content.features.map((feature) => ({
    icon: feature.iconUrl,
    title: feature.title,
    description: feature.body,
  }))
  const isExternalButtonUrl = /^(https?:\/\/|mailto:|tel:)/.test(content.buttonUrl)

  return (
    <section className={classes.content}>
      <div className={classes.textContainer}>
        <Text type={TextName.H2}>{content.title}</Text>

        <Text type={TextName.Text} className={classes.description}>
          {content.description}
        </Text>
      </div>

      <img
        src={isAboveLg ? content.desktopBackgroundUrl : content.mobileBackgroundUrl}
        alt='Customize and Deploy'
        className={classes.backgroundImage}
      />

      <FeaturesGrid features={features} className={classes.featuresGrid} />

      <div className={classes.buttonContainer}>
        <Button
          as={isExternalButtonUrl ? 'link' : 'router-link'}
          href={isExternalButtonUrl ? content.buttonUrl : undefined}
          to={!isExternalButtonUrl ? content.buttonUrl : undefined}
        >
          {content.buttonText}
        </Button>
      </div>
    </section>
  )
}
